import { render, staticRenderFns } from "./WxOfficialAct.vue?vue&type=template&id=4acc72dc&scoped=true&"
import script from "./WxOfficialAct.vue?vue&type=script&lang=js&"
export * from "./WxOfficialAct.vue?vue&type=script&lang=js&"
import style0 from "./WxOfficialAct.vue?vue&type=style&index=0&id=4acc72dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc72dc",
  null
  
)

export default component.exports